module.exports = __webpack_public_path__ + "img/e3-mascot.62a402d4.png";